export const AMS_MAINTENANCE_MODE = 'ams-maintenance-mode';
